module.exports = __webpack_public_path__ + "static/media/computer-dark.9783ff17.svg";